export enum EntriesTypeEnum {
  NAVIGATION = "navigation",
  RELOAD = "reload"
}
